import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Buttons/Button/Button';
import Label from '../../../../components/EntToEndUI/Label/Label';
import styles from './AboutUs.module.css';
import YoutubeStylePlayer from '../../../../components/Other/YoutubeStylePlayer/YoutubeStylePlayer';
import Accordion from '../../../../components/Other/Accordion/Accordion';
import { BeamIcon, CraneIcon, MountingIcon, LaserIcon, PhoneLineIcon, FileIcon, PlaneIcon, TreeIcon, RinkIcon, ShovelIcon } from '../../../../components/Other/Icons/Icons';


const AboutUs = () => {
  const { t } = useTranslation();
   // Данные для разделов аккордеона
   const accordionSections = [
    {
      title: 'Металлоконструкции',
      content: {
        description: 'Разработка проектной документации под требования вашей компании, производство и монтаж металлических конструкций.',
        images: [
          {
            title: 'БАЛКИ, КРОВЕЛЬНЫЕ ПРОГОНЫ',
            image: '/images/cards/metall/1.png',
          },
          {
            title: 'ФЕРМЫ СТРОПИЛЬНЫЕ И ТРЕХМЕРНЫЕ',
            image: '/images/cards/metall/2.png',
          },
          {
            title: 'КОЛОННЫ РЯДОВЫЕ И ТРЕХМЕРНЫЕ',
            image: '/images/cards/metall/3.png',
          },
          {
            title: 'СВЯЗИ, ФАХВЕРКОВЫЕ КОНСТРУКЦИИ',
            image: '/images/cards/metall/4.png',
          },
          {
            title: 'СЦЕНИЧЕСКИЕ КОНСТРУКЦИИ',
            image: '/images/cards/metall/5.png',
          },
          {
            title: 'ДЕКОРАЦИИ, МАФы',
            image: '/images/cards/metall/6.png',
          },
          {
            title: 'РЕКЛАМНЫЕ КОНСТРУКЦИИ',
            image: '/images/cards/metall/7.png',
          },
        ],
        link_to: 'services/metall'
      },
      icon: <BeamIcon color='var(--color-background)'/>
    },
    {
      title: 'Быстровозводимые здания',
      content: {
        description: 'Здания для вашего цеха на основе металлических конструкций - самое быстрое и экономически выгодное решение для вашего бизнеса. Средний срок возведения здания "под ключ" с момента заявки и проектирования до момента сдачи в эксплуатацию - 45 дней!',
        images: [
          {
            title: 'АНГАРЫ И СЕЛЬСКОХОЗЯЙСТВЕННЫЕ КОМПЛЕКСЫ',
            image: '/images/cards/speedbuildings/1.png',
          },
          {
            title: 'СКЛАДЫ ПРОМЫШЛЕННОГО И БЫТОВОГО НАЗНАЧЕНИЯ',
            image: '/images/cards/speedbuildings/2.png',
          },
          {
            title: 'АДМИНИСТРАТИВНО-БЫТОВЫЕ КОРПУСА И ОФИСНЫЕ ЗДАНИЯ',
            image: '/images/cards/speedbuildings/3.png',
          },
          {
            title: 'ТОРГОВЫЕ ПАВИЛЬОНЫ И МАГАЗИНЫ',
            image: '/images/cards/speedbuildings/4.png',
          },
        ],
        link_to: 'services/speedbuildings'
      },
      icon: <CraneIcon color='var(--color-background)'/>
    },
    {
      title: 'Строительно - монтажные работы',
      content: {
        description: 'Строительно-монтажные работы любой сложности, от подготовительных земляных работ до ввода здания в эксплуатацию',
        images: [
          {
            title: 'ПОДГОТОВИТЕЛЬНЫЕ, ЗЕМЛЯНЫЕ РАБОТЫ',
            image: '/images/cards/installation/1.png',
          },
          {
            title: 'МОНОЛИТНЫЕ, БЕТОННЫЕ, ЖЕЛЕЗОБЕТОННЫЕ РАБОТЫ',
            image: '/images/cards/installation/2.png',
          },
          {
            title: 'МОНТАЖ МЕТАЛЛИЧЕСКИХ КОНСТРУКЦИЙ',
            image: '/images/cards/installation/3.png',
          },
          {
            title: 'МОНТАЖ СЭНДВИЧ - ПАНЕЛЕЙ',
            image: '/images/cards/installation/4.png',
          },
          {
            title: 'УСТРОЙСТВО КРОВЛИ',
            image: '/images/cards/installation/5.png',
          },
          {
            title: 'УСТРОЙСТВО ШУМОИЗОЛЯЦИИ',
            image: '/images/cards/installation/6.png',
          },
          {
            title: 'ПРОЕКТНЫЕ И МОНТАЖНЫЕ РАБОТЫ ИНЖЕНЕРНЫХ СИСТЕМ И КОММУНИКАЦИЙ',
            image: '/images/cards/installation/7.png',
          },
        ],
        link_to: 'services/installation'
      },
      icon: <MountingIcon color='var(--color-background)'/>
    },
    {
      title: 'Обработка черных и цветных металлов',
      content: {
        description: 'Выполним задачу по обработке металлов любой сложности и объема, доверьте обработку металлов профессионалам, с гарантией качества!',
        images: [  
          {
            title: 'ЛАЗЕРНАЯ РЕЗКА МЕТАЛЛОВ И СПЛАВОВ',
            image: '/images/cards/lasers/2.png',
          },
          {
            title: 'ЛАЗЕРНАЯ РЕЗКА ТРУБ',
            image: '/images/cards/lasers/3.png',
          },
          {
            title: 'ГИБКА ЛИСТОВОГО МЕТАЛЛА И ПРОФИЛЯ',
            image: '/images/cards/lasers/1.png',
          },
          {
            title: 'КОНТАКТНАЯ СВАРКА',
            image: '/images/cards/lasers/4.png',
          },
          {
            title: 'АРГОННО-ДУГОВАЯ И ПОЛУАВТОМАТИЧЕСКАЯ СВАРКА',
            image: '/images/cards/lasers/5.png',
          },
          {
            title: 'ПОРОШКОВАЯ ОКРАСКА МЕТАЛЛИЧЕСКИХ ИЗДЕЛИЙ',
            image: '/images/cards/lasers/6.png',
          },
          {
            title: 'ПРОИЗВОДСТВО КОРПУСНЫХ ИЗДЕЛИЙ',
            image: '/images/cards/lasers/7.png',
          },
        ],
        link_to: 'services/lasers'
      },
      icon: <LaserIcon color='var(--color-background)'/>
    },
    {
      title: 'Нерудные сыпучие материалы',
      content: {
        description: 'Предлагаем широкий ассортимент нерудных сыпучих материалов для строительства, производства и промышленности. Широко применяются в строительстве, дорожном хозяйстве и благоустройстве территорий. Их главные преимущества: равномерное заполнение пространства, водонепроницаемость, негорючесть.',
        images: [
          {
            title: 'ГРУНТ КОТЛОВАННЫЙ, ПЛАНИРОВОЧНЫЙ, ПЛОДОРОДНЫЙ',
            image: '/images/cards/shove/1.png',
          },
          {
            title: 'ПЕСОК И ПЕСКОГРУНТ',
            image: '/images/cards/shove/2.png',
          },
          {
            title: 'ЩЕБЕНЬ ГРАНИТНЫЙ, ГРАВИЙНЫЙ, ВТОРИЧНЫЙ',
            image: '/images/cards/shove/3.png',
          },
          {
            title: 'АСФАЛЬТНАЯ КРОШКА, КЕРАМЗИТ, БЕТОННЫЙ БОЙ',
            image: '/images/cards/shove/4.png',
          }
        ],
        link_to: 'services/rink',
        iconDesc: "Продажа и доставка нерудных сыпучих материалов"
      },
      icon: <ShovelIcon color='var(--color-background)'/>,
      iconDesc: "Продажа и доставка нерудных сыпучих материалов" 
    },
    {
      title: 'Озеленение, благоустройство, ландшафтный дизайн',
      content: {
        description: 'Превратим Ваш участок в произведение искусства. Мы предлагаем полный спектр услуг по благоустройству, от ландшафтного дизайна до установки инженерных систем и коммуникаций. Создадим уникальный проект, учитывая Ваши пожелания и особенностей территории. Используем качественные материалы и современные технологии.',
        images: [
          {
            title: 'КОМПЛЕКСНОЕ БЛАГОУСТРОЙСТВО ТЕРРИТОРИИ',
            image: '/images/cards/tree/1.png',
          },
          {
            title: 'ОЗЕЛЕНЕНИЕ ЗЕМЕЛЬНЫХ УЧАСТКОВ',
            image: '/images/cards/tree/2.png',
          },
          {
            title: 'ДРЕНАЖНЫЕ СИСТЕМЫ, АВТОМАТИЧЕСКИЙ ПОЛИВ',
            image: '/images/cards/tree/3.png',
          },
          {
            title: 'ЛАНДШАФТНОЕ ПРОЕКТИРОВАНИЕ И ДИЗАЙН',
            image: '/images/cards/tree/4.png',
          },
        ],
        link_to: 'services/speedbuildings',
      },
      icon: <TreeIcon color='var(--color-background)'/>,
      iconDesc: "Озеленение, благоустройство, ландшафтный дизайн"
    },
    {
      title: 'Дорожные и земляные работы',
      content: {
        description: 'Мы выполняем полный комплекс земляных и дорожных работ любой сложности для строительства объектов различного назначения. Наша компания использует современную специализированную технику и опытный персонал для решения самых сложных задач.',
        images: [
          {
            title: 'РАЗРАБОТКА ГРУНТА, КОТЛОВАНОВ',
            image: '/images/cards/rink/1.png',
          },
          {
            title: 'УСТРОЙСТВО ПРОМЫШЛЕННЫХ ДОРОЖНЫХ ПОКРЫТИЙ',
            image: '/images/cards/rink/2.png',
          },
          {
            title: 'АСФАЛЬТИРОВАНИЕ ДОРОГ, ЯМОЧНЫЙ РЕМОНТ',
            image: '/images/cards/rink/3.png',
          },
          {
            title: 'МОЩЕНИЕ ДОРОЖЕК, ОТМОСТКА',
            image: '/images/cards/rink/4.png',
          }
        ],
        link_to: 'services/installation'
      },
      icon: <RinkIcon color='var(--color-background)'/>,
      iconDesc: "Продажа и доставка нерудных сыпучих материалов"
    }
  ];

  return (
    <section className={styles.main_about_us}>
      {/* <div className={styles.container}>
        <Label 
        topText={t('videoAboutUs.title')}
        bottomText={t('videoAboutUs.subTitle')}
        shift="medium"
        className="banner-label"
        />
      </div>
      <div className={styles.container}>
        <div className={styles.video_container}>
          <h2>Видео о нас</h2>
          <div className={styles.line}></div>
          <YoutubeStylePlayer 
              videoSrc="/videos/preview.mp4"
              posterSrc="/videos/preview.png"
              className={styles.aboutUsVideo}
            />
        </div>
      </div> */}
      <div className={styles.container}>
        <Accordion sections={accordionSections} />
      </div>
    </section>
  );
};

export default AboutUs; 